export default "__VITE_ASSET__nf7B4PqQ__"